import { render, staticRenderFns } from "./MarketApprove.vue?vue&type=template&id=3f92f866"
import script from "./MarketApprove.vue?vue&type=script&lang=js"
export * from "./MarketApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports